var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 1C11.8818 1 11.0858 1.27269 10.3842 1.81051C9.7115 2.32613 9.26366 2.98286 9 3.46041C8.73634 2.98283 8.2885 2.32613 7.61584 1.81051C6.91422 1.27269 6.11822 1 5.25 1C2.82713 1 1 2.96424 1 5.56902C1 8.38308 3.27947 10.3084 6.73028 13.2231C7.31628 13.7181 7.9805 14.2792 8.67088 14.8775C8.76188 14.9565 8.87875 15 9 15C9.12125 15 9.23813 14.9565 9.32913 14.8776C10.0196 14.2791 10.6838 13.7181 11.2701 13.2228C14.7205 10.3084 17 8.38308 17 5.56902C17 2.96424 15.1729 1 12.75 1Z",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.4dc70b6e10c8b556be5ec32b786c8043.svg";
export { ForwardRef as ReactComponent };